import { render, staticRenderFns } from "./TheRfqCard.vue?vue&type=template&id=5631e264&scoped=true"
import script from "./TheRfqCard.vue?vue&type=script&lang=js"
export * from "./TheRfqCard.vue?vue&type=script&lang=js"
import style0 from "./TheRfqCard.vue?vue&type=style&index=0&id=5631e264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631e264",
  null
  
)

export default component.exports